import React from "react"
import { IRecord } from "../types/schema"
import { HoverResourceLoader } from "./HoverResourceLoader"
import { KeyValueList } from "../Components/KeyValueList"

type IProduct = IRecord<"products", "stock_code" | "body" | "manufacturerCode" | "manufacturer">

interface IProps {
  id?: string
  initialData?: Partial<IProduct>
  renderInlineLink?: "block" | "inline"
  inline?: boolean
}

export function HoverProductLoader({ id, initialData, renderInlineLink, inline }: IProps) {
  const skeem = window.skeem

  async function loadData() {
    const product = await skeem.fetchOne<IProduct>({
      products: {
        attributes: ["stock_code", "body", "manufacturerCode"],
        filter: { matches: { id } },
      },
    })
    return product
  }

  if (!id) {
    return <span>-</span>
  }

  return (
    <HoverResourceLoader
      reloadKey={id}
      loadData={loadData}
      initialData={initialData}
      resourceName="Product"
      renderHoverContentTitle={record => record.stock_code}
      renderInlineLink={renderInlineLink}
      inline={inline}
      renderHoverContent={record => (
        <KeyValueList
          data={[
            { label: "Stock Code", value: record.stock_code },
            { label: "Name", value: record.body },
            { label: "MPN", value: record.manufacturerCode },
            { label: "Manufacturer", value: record.manufacturer },
          ]}
        />
      )}
      renderTarget={record => <span>{record.stock_code}</span>}
    />
  )
}
